import React from "react";
import "../page.css";
import firebase from "../../CONFIG/firebase.config";
import Gallery from "../Gallery/Gallery";
import arrow from '../img/arrow.png';


const Thanks =({fullname})=>

<div class="offer col-sm-12">
  {fullname} thank you for choosing us to help you experince the Magic 
  of Guyana
  </div>

const Welcome = (props)=>
<div className="offer col-sm-12">
   Providing Travel and Adventures Packages
  That Offer 20% less on Esseqiubo Tours for the first one hundred clients
</div>
                            
                            

const ActionButton =(props)=>
<div className="col-sm-12 mx-auto">
    <center>
        <button 
        class="animated 1 bounce delay-10s" 
        id="action-btn" 
        type="button"data-toggle="modal" 
        data-target="#myModal" 
        onclick="boom()">
              <img src={require("../img/btn.jpg")} className="img-responsive "/> 
          </button>
    </center>
</div>

const FaceBookButton =(props)=>
<div className="col-sm-12 mx-auto">
<center>
<a 
href="https://fb.me/ECATGT"
type='button'
class=" btn btn-primary btn-lg btn-block animated 1 bounce delay-10s" 
id="action-btn-fb" 
>
Contact Us On Facebook
  </a>
</center>
</div>


class FrontPage extends React.Component {

constructor(props) {
      super(props)
      this.state = {
          fullname: " ",
          register:false
      }
      this.handleFacebookAuth = this.handleFacebookAuth.bind(this);
      this.handleGoogleAuth = this.handleGoogleAuth.bind(this);

       
          
}

componentWillMount(){
  const self = this;
  firebase
  .auth()
  .getRedirectResult()
  .then(function(result) {
    if (result.credential) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential.accessToken;
      // ...
      var user = result.user;

      console.log({ user, token });
      // Redirect to an welcome screen
      const { displayName } = user;

      self.setState({
        register: !self.state.register,
        fullname:displayName
      })
    }
    // The signed-in user info.
    var user = result.user;
  })
  .catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    // ...
    console.log({ errorCode, errorMessage, email, credential });
  });
}

   handleGoogleAuth = e => {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider);
   }
   handleFacebookAuth = e => {
    e.preventDefault();
    var provider = new firebase.auth.FacebookAuthProvider();
    console.log("facebook provider instance", provider);
    firebase.auth().signInWithRedirect(provider);
  }

render () {

  return (
            <main>
                <div className="bg ">
                    <div className="main container">
                            <center>
                                <img src={require("../img/flag4.png")} className="animated infinite jello delay-4s"/>    
                            </center>
                              
                            <div className="row">
                                  
                              <div className="CityHeader col-lg-12">
                                <center>
                                  Eldorado City Adventure Tours
                                </center>
                              </div>
                            </div>
                        
                        
                          <div className="row">
                            {this.state.register ? <Thanks fullname={this.state.fullname}/> : <Welcome/>}}
                          </div>
                            <hr className="line"/>

                          <div className="row">
                          <div className="action col-sm-12 mx-auto">
                              <center>
                                    Take Action and Experience The Magic of Guyana
                              </center>
                          </div>
                          
                          </div>
                            

                         
                        <div className="row">

                          {this.state.register ? <FaceBookButton/>: <ActionButton/>}
                        
                        </div>
                  </div>


                  <div className="section">
                        <center>
                          <img 
                          className="animated infinite bounce delay-9s img-responsive "
                          src={arrow}/>
                        </center>
                  
                    </div>
                  </div>
                  <Gallery/>



















        <div class="modal" id="myModal">
          <div class="modal-dialog">
            <div class="modal-content">

              <div class="modal-header">
                <h4 class="modal-title">Subcribe Here</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>

              <div class="modal-body">
              
                <div class="facebook">
                  <button
                  onClick={this.handleFacebookAuth} 
                  type="button" class="btn btn-primary btn-block">Subcribe with Facebook</button>
                </div>
                <hr/>
                  <div class="google">
                  <button
                  onClick={this.handleGoogleAuth} 
                  type="button" class="btn btn-success btn-block">Subribe with google</button>
                  </div>

              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">X</button>
              </div>

            </div>
          </div>
        </div>
            </main>
          );
  }


}

export default FrontPage;
